var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4388 10.5597C27.8922 10.5597 27.4388 10.1064 27.4388 9.55971V7.13305C27.4388 6.15971 26.6522 5.37305 25.6788 5.37305H6.31884C5.3455 5.37305 4.55884 6.15971 4.55884 7.13305V9.57305C4.55884 10.1197 4.1055 10.573 3.55884 10.573C3.01217 10.573 2.55884 10.1197 2.55884 9.55971V7.13305C2.55884 5.05305 4.25217 3.37305 6.31884 3.37305H25.6788C27.7588 3.37305 29.4388 5.06638 29.4388 7.13305V9.57305C29.4388 10.1197 28.9988 10.5597 28.4388 10.5597Z",
    fill: "#3D48E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.999 28.6271C15.4524 28.6271 14.999 28.1738 14.999 27.6271V5.48047C14.999 4.9338 15.4524 4.48047 15.999 4.48047C16.5457 4.48047 16.999 4.9338 16.999 5.48047V27.6271C16.999 28.1871 16.5457 28.6271 15.999 28.6271Z",
    fill: "#3D48E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2525 28.627H10.7459C10.1992 28.627 9.74585 28.1736 9.74585 27.627C9.74585 27.0803 10.1992 26.627 10.7459 26.627H21.2525C21.7992 26.627 22.2525 27.0803 22.2525 27.627C22.2525 28.1736 21.7992 28.627 21.2525 28.627Z",
    fill: "#3D48E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.476c627021ac24d469969eb5e97619d9.svg";
export { ForwardRef as ReactComponent };